import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "container"
};
var _hoisted_2 = {
  class: "content-class"
};
var _hoisted_3 = {
  class: "number-panel mrg16"
};
var _hoisted_4 = {
  class: "body mrg16"
};
var _hoisted_5 = {
  class: "body-item"
};
var _hoisted_6 = {
  class: "echart-title"
};
var _hoisted_7 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_8 = {
  class: "body-item"
};
var _hoisted_9 = {
  class: "echart-title"
};
var _hoisted_10 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_11 = {
  class: "body-item"
};
var _hoisted_12 = {
  class: "echart-title"
};
var _hoisted_13 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_14 = {
  class: "teach-detail mrg16"
};
var _hoisted_15 = {
  key: 1,
  class: "empty-box"
};
import { getRectorByGrade, getRectorBySubject, getRectorDataSheet, getRectorPerCycle, getSchoolOrGrade, getTimeRecotorPeriod } from '@/api/index-guan';
import { ref, nextTick, reactive, computed, onMounted } from 'vue';
import FormItem from '../components/lib/FormItem';
import mTable from '../components/lib/Table';
import { TABLE_HEAD } from '../components/const/table';
import useUserStore from '@/stores/modules/user';
import analysisTab from '../components/analysisTab.vue';
import overviewPanel from '../components/overviewPanel.vue';
import PageSearch from '../components/PageSearch.vue';
import teachTab from '../components/teachTab.vue';
import barAnalysis from '../echarts/barAnalysis';
import lineAnalysis from '../echarts/lineAnalysis';
import { getStore } from '@/util/store';
export default {
  __name: 'schoolPage',
  setup: function setup(__props) {
    var schoolOptions = ref([]);
    var typeOptions = ref([{
      label: '月份',
      value: 1
    }, {
      label: '周',
      value: 0
    }]);
    var cycleType = ref(0);
    var cycleOptions = reactive({
      1: [],
      0: []
    });
    var userStore = useUserStore();
    var userInfo = getStore({
      name: 'userInfo'
    });
    var schoolId = ref('');
    var cycle = ref('');
    var type = ref('发起课堂数');
    var overviewRef = ref(null);
    var emptyImage = require('@/assets/home/dataReport/images/empty-chart.png');
    var emptyAllImage = require('@/assets/home/dataReport/images/empty-icon.png');
    // 获取时间周期
    var getTimeRecotorPeriodData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getTimeRecotorPeriod(1).then(function (res) {
                if (res.data.data) {
                  cycleOptions[1] = res.data.data.map(function (item) {
                    return {
                      label: item,
                      value: item
                    };
                  });
                } else {
                  cycleOptions[1] = [];
                }
              });
            case 1:
              _context.n = 2;
              return getTimeRecotorPeriod(0).then(function (res) {
                if (res.data.data) {
                  cycleOptions[0] = res.data.data.map(function (item) {
                    return {
                      label: item,
                      value: item
                    };
                  });
                  cycle.value = res.data.data[0];
                } else {
                  cycleOptions[0] = [];
                }
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getTimeRecotorPeriodData() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleChangeType = function handleChangeType() {
      cycle.value = cycleOptions[cycleType.value][0].value;
      handleChange();
    };
    var states = reactive({
      allGradeData: {},
      // 所有的对比分析数据-年级
      allSubjectData: {},
      // 对比分析数据-按学科
      allCycleData: {},
      // 对比比分析数据-按周期
      gradeData: {},
      // 对比分析数据-按年级
      subjectData: {},
      // 对比分析数据-按学科
      cycleData: {},
      // 比分析数据-按周期
      loading_grade: true,
      loading_subject: true,
      loading_cycle: true
    });
    var getAnalysisData = function getAnalysisData() {
      states.loading_grade = true;
      states.loading_subject = true;
      states.loading_cycle = true;
      var data = {
        schoolId: schoolId.value,
        cycle: cycle.value,
        cycleType: cycleType.value
      };
      // 获取校长模式对比分析-按年级
      getRectorByGrade(data).then(function (res) {
        states.loading_grade = false;
        // console.log(res.data.data, 114)
        var resData = res.data.data;
        states.allGradeData = resData;
        states.gradeData = dealGetNowSuitData(states.allGradeData);
        // console.log(states.gradeData)
      });
      // 获取校长模式对比分析-按学科
      getRectorBySubject(data).then(function (res) {
        states.loading_subject = false;
        var resData = res.data.data;
        states.allSubjectData = resData;
        states.subjectData = dealGetNowSuitData(states.allSubjectData);
        // console.log(states.subjectData)
      });
      // 获取校长模式对比分析-按周期
      getRectorPerCycle(data).then(function (res) {
        states.loading_cycle = false;
        // console.log(res.data.data, 123)
        var resData = res.data.data;
        states.allCycleData = resData;
        states.cycleData = dealGetNowSuitData(states.allCycleData);
        // console.log(states.cycleData)
      });
    };
    var showGrade = computed(function () {
      var series = states.gradeData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var showSubject = computed(function () {
      var series = states.subjectData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var showCycle = computed(function () {
      var series = states.cycleData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var dealGetNowSuitData = function dealGetNowSuitData(searchData) {
      var reLegend = [];
      var reSeries = [];
      reLegend = searchData.legend.filter(function (item) {
        return item.indexOf(type.value) > -1;
      });
      reSeries = searchData.series.filter(function (item) {
        return item.name.indexOf(type.value) > -1;
      });
      // console.log(reSeries, 209)
      return {
        legend: reLegend,
        series: reSeries,
        showTitle: false,
        isRate: type.value.indexOf('率') > -1,
        title: searchData.title,
        xaxis: searchData.xaxis
      };
    };
    // 切换类型
    var handleAnalyTab = function handleAnalyTab(val) {
      type.value = val.label;
      // 处理数据
      states.gradeData = dealGetNowSuitData(states.allGradeData);
      states.subjectData = dealGetNowSuitData(states.allSubjectData);
      states.cycleData = dealGetNowSuitData(states.allCycleData);
    };

    // 表格数据
    var columns = ref(TABLE_HEAD.noTablecolumn);
    var tdata = ref([]);
    var size = ref(20);
    var current = ref(1);
    var classType = ref('');
    var grade = ref('');
    var subject = ref('');
    var isUse = ref('');
    var total = ref(0);
    var handleChange = function handleChange() {
      // 获取对比分析
      getAnalysisData();
      current.value = 1;
      size.value = 20;
      // 获取教师授课详情
      getRecotorData();
      // 获取总览
      nextTick(function () {
        overviewRef.value.getPanelOverview();
      });
    };
    // 学校名称
    var schoolName = computed(function () {
      var _schoolOptions$value$;
      return (_schoolOptions$value$ = schoolOptions.value.find(function (item) {
        return item.id === schoolId.value;
      })) === null || _schoolOptions$value$ === void 0 ? void 0 : _schoolOptions$value$.name;
    });
    // 获取教师授课详情
    var getRecotorData = function getRecotorData() {
      var data = {
        classType: classType.value,
        grade: grade.value,
        subject: subject.value,
        isUse: isUse.value,
        size: size.value,
        current: current.value,
        schoolId: schoolId.value,
        cycle: cycle.value,
        cycleType: cycleType.value
      };
      getRectorDataSheet(data).then(function (res) {
        // console.log(res.data, 166)
        tdata.value = res.data.data.records;
        total.value = res.data.data.total;
      });
    };
    // 切换有无，班级数据信息
    var handleChangeTab = function handleChangeTab(val) {
      classType.value = val.classType;
      grade.value = val.grade;
      subject.value = val.subject;
      isUse.value = val.isUse ? 1 : 0;
      columns.value = val.isUse ? TABLE_HEAD.tablecolumn : TABLE_HEAD.noTablecolumn;
      current.value = 1;
      size.value = 20;
      getRecotorData();
    };
    var changePageSize = function changePageSize(num) {
      current.value = 1;
      size.value = num;
      getRecotorData();
    };
    var changeCurrent = function changeCurrent(num) {
      current.value = num;
      getRecotorData();
    };
    // 获取学校信息
    var getSchoolListData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              data = {
                userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                type: 0
              };
              _context2.n = 1;
              return getSchoolOrGrade(data).then(function (res) {
                // console.log(res)
                schoolOptions.value = res.data.data || [];
                if (schoolOptions.value.length) {
                  schoolId.value = schoolOptions.value[0].id;
                } else {
                  schoolId.value = '';
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getSchoolListData() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return getSchoolListData();
          case 1:
            _context3.n = 2;
            return getTimeRecotorPeriodData();
          case 2:
            // 获取总览
            overviewRef.value.getPanelOverview();
            getAnalysisData();
            getRecotorData();
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    })));
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_Loading = _resolveComponent("Loading");
      var _component_Empty = _resolveComponent("Empty");
      return schoolOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(PageSearch, null, {
        default: _withCtx(function () {
          return [schoolOptions.value.length > 1 ? (_openBlock(), _createBlock(_unref(FormItem), {
            key: 0
          }, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 学校 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: schoolId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return schoolId.value = $event;
                }),
                options: schoolOptions.value,
                keys: {
                  label: 'name',
                  value: 'id'
                },
                onChange: handleChange
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" 类型 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: cycleType.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return cycleType.value = $event;
                }),
                style: {
                  "width": "100px"
                },
                options: typeOptions.value,
                onChange: handleChangeType
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode(" 时间周期 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: cycle.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return cycle.value = $event;
                }),
                style: {
                  "width": "210px"
                },
                options: cycleOptions[cycleType.value],
                onChange: handleChange
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createVNode(overviewPanel, {
        ref_key: "overviewRef",
        ref: overviewRef,
        class: "mrg16",
        schoolId: schoolId.value,
        cycle: cycle.value,
        cycleType: cycleType.value
      }, null, 8, ["schoolId", "cycle", "cycleType"]), _createElementVNode("div", _hoisted_3, [_createVNode(analysisTab, {
        onTabChange: handleAnalyTab
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_svg_icon, {
        class: "svg-class",
        size: 32,
        name: "analy-image"
      }), _cache[6] || (_cache[6] = _createElementVNode("span", null, "按周期", -1))]), states.loading_cycle ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_withDirectives(_createVNode(_unref(lineAnalysis), {
        id: "echart",
        data: states.cycleData
      }, null, 8, ["data"]), [[_vShow, showCycle.value]]), _withDirectives(_createVNode(_component_Empty, {
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]), [[_vShow, !showCycle.value]])], 64))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_svg_icon, {
        class: "svg-class",
        size: 32,
        name: "analy-image"
      }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "按年级", -1))]), states.loading_grade ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_withDirectives(_createVNode(_unref(barAnalysis), {
        id: "echart1",
        data: states.gradeData
      }, null, 8, ["data"]), [[_vShow, showGrade.value]]), _withDirectives(_createVNode(_component_Empty, {
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]), [[_vShow, !showGrade.value]])], 64))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_svg_icon, {
        class: "svg-class",
        size: 32,
        name: "analy-image"
      }), _cache[8] || (_cache[8] = _createElementVNode("span", null, "按学科", -1))]), states.loading_subject ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_withDirectives(_createVNode(_unref(barAnalysis), {
        id: "echart2",
        data: states.subjectData
      }, null, 8, ["data"]), [[_vShow, showSubject.value]]), _withDirectives(_createVNode(_component_Empty, {
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]), [[_vShow, !showSubject.value]])], 64))])])]), _createElementVNode("div", _hoisted_14, [_createVNode(teachTab, {
        class: "tab-class",
        schoolName: schoolName.value,
        cycle: cycle.value,
        schoolId: schoolId.value,
        userId: _unref(userInfo).id,
        cycleType: cycleType.value,
        onChangeTab: handleChangeTab
      }, null, 8, ["schoolName", "cycle", "schoolId", "userId", "cycleType"]), _createVNode(_unref(mTable), {
        class: "mrg16",
        columns: columns.value,
        tdata: tdata.value,
        total: total.value,
        pageSize: size.value,
        current: current.value,
        onChangeCurrent: changeCurrent,
        onChangePageSize: changePageSize
      }, null, 8, ["columns", "tdata", "total", "pageSize", "current"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_Empty, {
        icon: _unref(emptyAllImage),
        "full-height": true
      }, {
        description: _withCtx(function () {
          return _toConsumableArray(_cache[9] || (_cache[9] = [_createElementVNode("div", {
            class: "empty-des"
          }, [_createElementVNode("p", null, "当前尚无校长数据权限"), _createElementVNode("p", null, "请找管理员进行应用授权范围设定")], -1)]));
        }),
        _: 1
      }, 8, ["icon"])]));
    };
  }
};